const JapaneeseReplacePatterns = [
/*
厚生労働省：異体字検索漢字リストから
https://www.mhlw.go.jp/seisakunitsuite/bunya/kenkou_iryou/iryou/dl/itaiji.pdf
	"亜亞", "悪惡", "庵菴",
	"韋", "違", "為爲", "飴", "蔚", "壱壹",
	"逸", "陰", "蔭", "隠隱",
	"宇", "雨", "羽羽",
	"英", "栄榮", "衛衞", "曳曵", "穎頴", "益益", "悦悅", "円圓", "延", "遠", "塩鹽", "縁", "媛", "燕", "淵渕渊",
	"桜櫻", "翁", "応應",	"横橫", "欧歐", "鴬鶯", "奥奧", "温",

	"花", "華", "嘉", "仮假", "迦", "海", "会會", "快", "絵繪", "桧檜", "晦", "鶴靏鶴", "覚覺", "撹攪",
		"楽樂", "学學斈", "鍔", "葛", "間閒", "簡", "寛寬", "関關", "館舘館", "環", "侃", "漢", "巻卷",
		"鑑", "雁鴈鳫", "巌巖", "岸", "顔顏", "帰歸", "亀龜", "気气氣", "喜憙", "禧", "熙煕熈", "起", "祈",
	"輝", "旗籏", "姫", "逆", "厩廐廏", "鬮", "旧舊", "強", "教敎", "郷鄕", "橋", "卿", "饗", "響", "尭堯",
		"暁曉", "近", "勤", "謹",
	"君", "薫薰", "勲勳",
	"契", "恵惠", "敬", "啓", "慧", "鶏鷄", "経經", "継繼", "繋", "渓溪谿", "蛍螢", "潔", "穴", "研", "県縣", "兼",
		"憲", "謙", "建", "剣劍劔劒剱釼", "顕顯", "献獻", "絹", "権權", "迎", "芸藝", "彦", "原", "源", "厳嚴",
	"壷壺", "込", "顧", "呉", "恒恆", "広廣", "弘", "耕畊", "高髙", "黄", "港", "構", "溝", "鉱鑛", "鉤鈎", "浩",
		"皓", "塙", "更", "巷", "興", "号號", "国國圀", "黒黑", "穀",

	"鎖", "蓑簑簔", "歳", "菜", "済濟", "斉齊斎齋", "蔡", "榊", "崎﨑嵜", "迫", "柵", "薩", "座坐", "雑雜", "桟棧",
	"姉", "史", "茨", "柿", "視", "歯齒", "滋", "児兒", "爾尓", "櫛", "実實", "舎舍", "捨", "社", "釈釋", "袖",
		"寿壽", "儒", "周", "収收", "秋", "従從", "渋澁澀", "重", "祝", "粛肅", "遵", "潤", "純", "所", "緒緖", "諸諸",
		"曙", "初", "処處", "渚", "叙敍敘", "徐", "鍾", "咲", "昇", "松枩", "承", "宵", "祥祥", "称", "笑", "照",
		"勝", "翔", "肖", "梢", "将將", "蒋", "篠筱", "蛸", "尚", "焼燒", "奨奬獎", "条條", "丈", "冗", "乗乘", "場塲",
		"譲讓", "壤壌", "縄繩", "浄淨", "穣穰", "触觸", "進", "真眞", "寝寢", "慎愼", "槙槇", "晋晉", "神神", "尋", "刃刄", "侭儘",
	"図圖", "厨廚", "垂埀", "穂穗", "翠", "数數",
	"瀬", "清淸", "晴晴", "晢", "聖", "青靑", "静靜", "精精", "声聲", "成", "誠", "盛", "靖靖", "雪", "節", "摂攝",
		"船舩", "蝉", "箭", "揃", "扇", "浅淺", "専專", "銭錢", "戦戰", "前", "善", "禅禪",
	"祖", "曾曽", "蘇蘓", "荘莊", "桑", "巣", "薮藪籔", "草艸", "総總",
	"聡聰", "壮壯", "装裝", "竃竈", "造", "増", "像", "蔵藏", "属屬", "尊", "巽", "鱒", "樽", "村邨",

	"多夛", "帯帶", "泰", "台臺", "黛", "対對", "体躰軆體", "滝瀧", "沢澤", "琢", "達逹", "単單", "灘", "段", "騨", "弾彈", "団團",
	"遅遲", "竺", "筑", "昼晝", "猪猪", "箸", "趙", "朝", "調", "潮", "張",
	"塚塚", "肇", "勅敕", "鎮鎭",
	"槌", "通", "辻",
	"呈", "程", "禎", "鄭", "迪廸", "天", "鉄鐵鐡", "伝傳",
	"戸", "兎菟兔莵", "堵", "唐", "島嶋嶌", "透", "藤", "統", "祷", "塘", "樋", "湯", "当當", "稲稻", "道",
		"峠垰", "徳德", "独獨", "読讀", "栃杤",

	"那", "内", "難",
	"忍", "弐弍貳貮",
	"祢禰",
	"納",

	"派", "覇霸", "馬", "裴", "杯盃", "拝拜", "梅", "博", "薄", "柏栢", "麦麥",
	"発發", "抜拔", "繁", "半", "藩", "飯飯",
	"妃", "斐", "弥彌", "鼻", "薇", "苗", "浜濵濱", "敏",
	"富冨", "敷", "榑", "釜釡", "武", "風凬", "服", "福福", "覆", "仏佛", "文",
	"平", "柄", "幣", "并", "坪", "屏", "餅", "返", "辺邊邉", "卞", "弁辨辧瓣辯",
	"歩", "舗鋪舖", "邦", "包", "宝寶寳", "縫", "逢", "峰峯", "豊豐", "朋", "棚", "蓬", "萌萠", "房", "望", "卯夘", "盆",

	"摩", "磨", "麻", "毎", "桝枡", "俣", "麿", "万萬", "満滿",
	"免",
	"謨", "茂", "網", "黙默", "籾",

	"野", "耶", "薬藥", "鑓",
	"諭", "兪", "瑜", "楡", "猶", "遊", "雄", "優", "祐", "裕", "猷", "楢", "又",
	"与與", "誉譽", "餘", "予豫", "葉", "楊", "揚", "耀", "曜", "謡謠", "遥遙", "瑶瑤", "翼",

	"来來徠", "莱", "頼賴", "藍", "蘭",
	"吏", "柳栁", "留畄", "隆", "劉", "竜龍", "旅", "梁", "遼", "涼凉", "緑綠", "鈴",
	"類",
	"令", "礼礼禮", "怜", "齢齡", "蛎蠣", "歴", "廉", "鎌", "簾", "蓮", "錬",
	"芦蘆", "枦櫨", "楼樓", "労勞", "篭籠", "禄祿",

	"いゐ", "えゑヱ", "おを", "こ", "し", "せ", "ふ",
*/
// 文字化けを除いたもの
	"亜亞", "悪惡", "庵菴",
	"為爲", "飴", "蔚", "壱壹",
	"隠隱",
	"羽羽",
	"栄榮", "衛衞", "曳曵", "穎頴", "益益", "悦悅", "円圓", "淵渕渊", "桜櫻", "応應",	"横橫", "欧歐", "鴬鶯", "奥奧",

	"仮假", "会會", "絵繪", "桧檜", "晦", "鶴靏鶴", "覚覺", "撹攪", "楽樂", "学學斈", "間閒", "寛寬", "関關", "館舘館", "巻卷",
		"雁鴈鳫", "巌巖", "顔顏", "帰歸", "亀龜", "気气氣", "喜憙", "熙煕熈",
	"旗籏", "厩廐廏", "旧舊", "教敎", "郷鄕", "尭堯",	"暁曉",
	"薫薰", "勲勳",
	"恵惠", "鶏鷄", "経經", "継繼", "渓溪谿", "蛍螢", "県縣", "剣劍劔劒剱釼", "顕顯", "献獻", "権權", "芸藝", "厳嚴",
	"壷壺", "恒恆", "広廣", "耕畊", "高髙", "鉱鑛", "鉤鈎", "号號", "国國圀", "黒黑",

	"蓑簑簔", "済濟", "斉齊斎齋", "崎﨑嵜", "迫", "柵", "薩", "座坐", "雑雜", "桟棧",
	"歯齒", "児兒", "爾尓", "実實", "舎舍", "釈釋", "寿壽", "収收", "従從", "渋澁澀", "粛肅", "緒緖", "諸諸", "処處", "叙敍敘",
		"松枩", "祥祥", "将將", "篠筱", "焼燒", "奨奬獎", "条條", "乗乘", "場塲", "譲讓", "壤壌", "縄繩", "浄淨", "穣穰", "触觸",
		"真眞", "寝寢", "慎愼", "槙槇", "晋晉", "神神", "尋", "刃刄", "侭儘",
	"図圖", "厨廚", "垂埀", "穂穗", "数數",
	"清淸", "晴晴", "青靑", "静靜", "精精", "声聲", "靖靖", "摂攝", "船舩", "浅淺", "専專", "銭錢", "戦戰", "禅禪",
	"曾曽", "蘇蘓", "荘莊", "薮藪籔", "草艸", "総總",
	"聡聰", "壮壯", "装裝", "竃竈", "蔵藏", "属屬", "村邨",

	"多夛", "帯帶", "台臺", "対對", "体躰軆體", "滝瀧", "沢澤", "琢", "達逹", "単單", "弾彈", "団團",
	"遅遲", "昼晝", "猪猪",
	"塚塚", "勅敕", "鎮鎭",
	"迪廸", "鉄鐵鐡",
	"兎菟兔莵", "島嶋嶌", "当當", "稲稻", "峠垰", "徳德", "独獨", "読讀", "栃杤",

	"弐弍貳貮",
	"祢禰",

	"覇霸", "杯盃", "拝拜", "柏栢", "麦麥",
	"発發", "抜拔", "飯飯",
	"弥彌", "浜濵濱",
	"富冨", "釜釡", "風凬", "福福", "仏佛",
	"辺邊邉", "弁辨辧瓣辯",
	"舗鋪舖", "宝寶寳", "峰峯", "豊豐", "萌萠", "卯夘",

	"桝枡", "万萬", "満滿",
	"黙默",

	"薬藥",
	"与與", "誉譽", "予豫", "謡謠", "遥遙", "瑶瑤",

	"来來徠", "頼賴",
	"柳栁", "留畄", "竜龍", "涼凉", "緑綠",
	"礼礼禮", "齢齡", "蛎蠣",
	"芦蘆", "枦櫨", "楼樓", "労勞", "篭籠", "禄祿",

	"いゐ", "えゑヱ", "おを",

	// 漢数字／大字
	"一壱", "二弐", "三参", "四肆", "五伍",
	"六陸", "七漆", "八捌", "九玖", "十拾",
	"百佰", "千阡",

	// 実際にあったケース
	"桒桑", "八矢", "琢琢"
]

export const enumJapaneeseReplacePattern = (
	base: string
) => JapaneeseReplacePatterns.flatMap(patternText => {
	const reg = new RegExp(`[${patternText}]`, "ig")
	if (!reg.test(base)) return []
	const match = base.match(reg)
	if (!match) return []

	const charList = patternText.split("")
	return match
		.flatMap(e => charList.map(w => base.replace(e, w)))
		.filter(r => r !== base)
})